import { KYC_STATUS_ONBOARDING_NOT_FINISHED } from "@/hooks/useNeedsIDCheck";
import { IdentificationStatusResponseKycStatus } from "@/services/model";
import { isIdCheckPageActionable } from "@/utils/kycTodoConfig";

export type AddDeviceSuccessNextStep =
  | { type: "wait" }
  | { type: "idCheck"; fromOrder: boolean }
  | { type: "personalData" }
  | { type: "cockpit" };

const RETRY_ID_CHECK_STATUSES = new Set<string>([
  IdentificationStatusResponseKycStatus.KYC_invalid_document,
  IdentificationStatusResponseKycStatus.KYC_ID_uncomparable,
  IdentificationStatusResponseKycStatus.KYC_error_processing_docs,
  IdentificationStatusResponseKycStatus.KYC_error_processing_selfie,
]);

/**
 * Maps KYC status after add-device checkout to the handoff page's next action.
 * `wait` = keep thank-you UI and keep polling (unsettled / fraud check).
 */
export const getAddDeviceSuccessNextStep = (
  kycStatus: string | undefined,
  isVerified?: boolean,
): AddDeviceSuccessNextStep => {
  if (
    !kycStatus ||
    kycStatus === KYC_STATUS_ONBOARDING_NOT_FINISHED ||
    kycStatus === IdentificationStatusResponseKycStatus.FRAUD_CHECK_PENDING
  ) {
    return { type: "wait" };
  }

  if (
    isVerified === true &&
    kycStatus === IdentificationStatusResponseKycStatus.OK
  ) {
    return { type: "cockpit" };
  }

  if (kycStatus === IdentificationStatusResponseKycStatus.OPEN) {
    return { type: "idCheck", fromOrder: true };
  }

  if (RETRY_ID_CHECK_STATUSES.has(kycStatus)) {
    return { type: "idCheck", fromOrder: false };
  }

  if (kycStatus === IdentificationStatusResponseKycStatus.KYC_data_mismatch) {
    return { type: "personalData" };
  }

  // PENDING, underaged, max attempts, unknown non-actionable → cockpit todos
  if (!isIdCheckPageActionable(kycStatus)) {
    return { type: "cockpit" };
  }

  // Unknown actionable status: treat like OPEN without order framing
  return { type: "idCheck", fromOrder: false };
};
